// firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from "firebase/auth";
import { 
  getFirestore
} from "firebase/firestore";
import { 
  getStorage
} from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCfSRJC-k0tfn0RbGimgiZauBO_LWyZN8k",
  authDomain: "neoguitarstore-a951b.firebaseapp.com",
  projectId: "neoguitarstore-a951b",
  storageBucket: "neoguitarstore-a951b.firebasestorage.app",
  messagingSenderId: "420292015196",
  appId: "1:420292015196:web:920462dfc207044c79e299",
  measurementId: "G-5P9XDECG2H"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { 
  auth, 
  db, 
  storage,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged
};